<template>
  <div class="about" data-testid="portfolio-about">
    <HelperViewStatus
      v-if="hasError"
      class="about__helper"
      title="Não foi possível carregar as informações"
      description="Aguarde um momento e tente novamente"
      button-label="Tentar novamente"
      status="alert"
      @click="getAboutData"
    />
    <template v-else>
      <AboutStrategy
        class="about__section"
        :risk-profile="aboutData?.riskProfile"
        :strategy="aboutData?.strategy"
        :is-loading="isLoading"
      />
      <TechnicalDetails
        class="about__section"
        :details="aboutData?.details"
        :is-loading="isLoading"
      />
    </template>
    <AboutLinks
      class="about__section"
      :about-data="aboutData"
      @toggle-configuration-modal="toogleConfigurationModal"
    />
    <PaidEventsConfigurationModal
      :is-open="isConfigurationModalOpen"
      :paid-events-configuration="aboutData?.paidEventConfig"
      @close="toogleConfigurationModal"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, provide } from 'vue';

import { HelperViewStatus } from '@warrenbrasil/nebraska-web';
import { AboutStrategy } from './components/AboutStrategy';
import { TechnicalDetails } from './components/TechnicalDetails';
import { AboutLinks } from './components/AboutLinks';

import {
  getPortfolioAbout,
  PortfolioAboutData
} from '@/modules/wealth/services/portfolio';
import { PaidEventsConfigurationModal } from './components/PaidEvents/components/PaidEventsConfigurationModal';
interface Props {
  portfolioId: string;
}
const props = defineProps<Props>();

const isLoading = ref(true);
const hasError = ref(false);
const aboutData = ref<PortfolioAboutData | null>(null);
const isConfigurationModalOpen = ref(false);

const getAboutData = async () => {
  isLoading.value = true;
  hasError.value = false;
  try {
    const data = await getPortfolioAbout(props.portfolioId);

    aboutData.value = data.about;
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
};

const toogleConfigurationModal = () => {
  isConfigurationModalOpen.value = !isConfigurationModalOpen.value;
};

provide('getAboutData', getAboutData);

onMounted(async () => {
  await getAboutData();
});
</script>

<style lang="less" scoped>
.about {
  margin: @size-spacing-x800 auto 0 auto;
  padding: 0 @size-spacing-x400;

  .from-md({
    max-width: calc(800px + 2 * @size-spacing-x800);
    padding: 0 @size-spacing-x800;
  });

  &__helper {
    margin: @size-spacing-x600 auto @size-spacing-x600 auto;
  }

  &__section {
    margin-bottom: @size-spacing-x1000;

    &:last-child {
      margin-bottom: 0px;
    }
  }
}
</style>
